import { mutationFor, queryFor } from "@visioni/a3s-client-api/app";
import { recordActivityEndpoint } from "../client-messages/record-activity";
import { listActivityEndpoint } from "../client-messages/list-activity";

export const recordActivityMutation = mutationFor(recordActivityEndpoint);

export const listActivityQuery = queryFor(listActivityEndpoint);
